import React, { useState, useEffect, useContext } from 'react';

import { getData } from '../../constants/api_index';
import { LayoutContext } from '../../context/layoutContext';
import { Body } from '../../styles/homeStyles';

import ContentsMainBox from '../../components/common/ContentsMainBox';
import ContentsList from './ContentsList';
import ButtonTabs from '../common/ButtonTabs';
import TabPanel from '../common/TabPanel';
import _ from 'lodash';

import { useHistory } from 'react-router-dom';

import { connect } from 'react-redux';

const TAB = ['오늘의 본방송', '주간 BEST 방송', '최신 프로그램'];
const API = ['schedule/todayLive', 'episode/weeklyBest', 'search/latest'];

const MainVodList = ({ programData }) => {
  const { matchese } = useContext(LayoutContext);
  const history = useHistory();
  const [tabValue, setTabvalue] = useState(2);

  const [todayLiveList, setTodayLiveList] = useState([]);

  const [bestMain, setBestMain] = useState({});
  const [bestLiveList, setBestLiveList] = useState([]);

  const [latestMain, setLatestMain] = useState({});
  const [latestList, setlatestList] = useState([]);

  useEffect(() => {
    if (programData?.program?.length > 0) {
      getDataList();
    }
  }, [programData]);

  const getDataList = () => {
    Promise.all([getData(API[0]), getData(API[1]), getData(API[2])]).then(res => {
      res.map((api, idx) => {
        if (api) {
          let arr;
          let main;

          arr = _.cloneDeep(idx === 1 ? api?.val : api?.value);

          // 본방송 프로그램 등록되있는걸로 교체..
          arr.map(r => {
            programData?.program.map(pg => {
              if (idx === 0) {
                if (pg?.id === r?.program?.id) r.program = pg;
              } else if (idx === 1) {
                if (pg?.id === r?.programId) r.episode.Item.programImage = pg?.img instanceof Array ? pg?.img[0]?.url : pg?.img?.url;
              } else if (idx === 2) {
                if (pg?.id === r?.programId) {
                  r.programImage = pg?.img instanceof Array ? pg?.img[0]?.url : pg?.img?.url;
                }
              }
            });
          });

          // 주간 BEST / 최신 VOD 메인 vod 추출.
          if (idx !== 0) {
            main = _.cloneDeep(arr[0]);

            arr = _.cloneDeep(
              arr.filter((d, i) => {
                if (i > 0) return d;
              }),
            );
          }

          // 주간 best 필드 빼내기.
          if (idx === 1) {
            let _arr = [];
            let _main = main?.episode?.Item;
            arr.map(item => _arr.push(item?.episode?.Item));

            let filterArr = _arr.reduce((element, v) => {
              return element.find(x => x.id === v.id) ? element : [...element, v];
            }, []);

            main = _main;
            arr = filterArr;
          }

          // 오늘의 본방송
          if (idx === 0) setTodayLiveList(arr ? arr : []);

          // 주간 best 방송
          if (idx === 1) {
            setBestMain(main);
            setBestLiveList(arr ? arr : []);
          }

          // 최신 vod 방송
          if (idx === 2) {
            setLatestMain(main);
            setlatestList(arr ? arr : []);
          }
        }
      });
    });
  };

  const handleCangeTab = e => {
    setTabvalue(e);
  };

  const goDetail = (data, type) => {
    if (!data?.id) return;
    let url;

    if (type === 'vod') {
      url = `/program-detail?id=${data.programId}&ep=${data.id}&tab=1`;
    } else if (type === 'program') {
      url = `/vod-detail?id=${data.episode.programId}&tab=0`;
    }

    history.push(process.env.PUBLIC_URL + url);
  };

  return (
    <Body Pb={true} Ptb={matchese}>
      <ButtonTabs tabList={TAB} value={tabValue} rtValue={handleCangeTab} />
      <TabPanel value={tabValue} index={0}>
        <ContentsList
          list={todayLiveList}
          type='today-program'
          detail='today-program'
          optionType='sideArrow'
          contetentHeight='180px'
          playBtn={true}
          imgOpacity={true}
          showCnt={matchese ? 1 : 4}
          animation='select'
        />
      </TabPanel>

      <TabPanel value={tabValue} index={1} style={{ margin: matchese ? '20px 0 0 0' : '0' }}>
        <ContentsMainBox
          data={bestMain}
          type='main-vod'
          freePlayBtn={true}
          imgOpacity={true}
          animation='select'
          goDetail={() => goDetail(bestMain, 'vod')}
          contetentWidth='100%'
          contetentHeight={matchese ? '180px' : '430px'}
          margin={matchese ? '10px 0 0 0' : '10px 0 0 0'}
        />
        <ContentsList
          list={bestLiveList}
          type='main-vod'
          detail='vod-detail'
          optionType='sideArrow'
          contetentHeight={matchese ? '120px' : '159px'}
          playBtn={true}
          imgOpacity={true}
          animation='select'
          showCnt={matchese ? 2 : 4}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={2} style={{ margin: matchese ? '20px 0 0 0' : '0' }}>
        <ContentsMainBox
          data={latestMain}
          type='main-vod'
          freePlayBtn={true}
          imgOpacity={true}
          animation='select'
          goDetail={() => goDetail(latestMain, 'vod')}
          contetentWidth='100%'
          contetentHeight={matchese ? '180px' : '430px'}
          margin={matchese ? '10px 0 0 0' : '10px 0 0 0'}
        />
        <ContentsList
          list={latestList}
          type='main-vod'
          detail='vod-detail'
          optionType='sideArrow'
          contetentHeight={matchese ? '120px' : '159px'}
          playBtn={true}
          imgOpacity={true}
          animation='select'
          showCnt={matchese ? 2 : 4}
        />
      </TabPanel>
    </Body>
  );
};

const mapStateToProps = state => {
  return {
    programData: state.programData,
  };
};

export default connect(mapStateToProps)(MainVodList);
